import { render, staticRenderFns } from "./LandingTypes.vue?vue&type=template&id=73be85ec&"
import script from "./LandingTypes.vue?vue&type=script&lang=js&"
export * from "./LandingTypes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports